<template>
    <base-layout title="个人信息收集清单" :hideFooter="true">
        <template slot="main">
            <div class="page-body">
                <p>清单说明：本清单将帮助您了解我们对您的个人信息的收朱和使用情况。我们将严格依照法律法规收集、处理您的个人信息并保护您的隐私安全，您可以查阅隐私政策了解详细信息。</p>
                <ul>
                    <li @click="$router.push('/system/statute/collection/baseInfo')">
                        <strong>基本信息</strong>
                        <i class="dmicon dm-xiangyoujiantou"></i>
                    </li>
                    <li @click="$router.push('/system/statute/collection/serviceProcessInfo')">
                        <strong>服务过程相关信息</strong>
                        <i class="dmicon dm-xiangyoujiantou"></i>
                    </li>
                    <li @click="$router.push('/system/statute/collection/deviceUseInfo')">
                        <strong>设备使用信息</strong>
                        <i class="dmicon dm-xiangyoujiantou"></i>
                    </li>
                </ul>
            </div>
        </template>
    </base-layout>
</template>

<script>
// 页面布局组件
import baseLayout from "@comm/view/layout/baseLayout";

export default {
    name: 'systemStatuteCollectionCollectionList',
    components: {
        // 页面布局组件
        baseLayout,
    },
    data() {
        return {}
    },
}
</script>

<style lang="scss" scoped>
.page-body {
    padding: 10px;

    p {
        color: gray;
        font-size: 12px;
    }

    ul {
        li {
            display: flex;
            position: relative;
            align-content: center;
            align-items: center;
            height: 1.4rem;
            justify-content: space-between;
            border-bottom: solid 0.025rem #efeff1;
            strong{
                color: #585858;
                font-size: 0.4rem;
                font-weight: normal;
            }
        }
    }
}
</style>